





import { defineComponent } from '@vue/composition-api';
import { Portal as VueSimplePortal } from '@linusborg/vue-simple-portal';
import { PortalConstants } from '../constants/portal.constants';

export default defineComponent({
  components: {
    VueSimplePortal,
  },
  props: {
    targetElementId: {
      type: String,
      default: PortalConstants.elementId,
    },
  },
});
